import React from 'react';
import { ShieldBan, DoorOpen } from 'lucide-react';
import { useServerStore } from '../../store/serverStore';

interface BannedServerScreenProps {
  serverName: string;
}

const BannedServerScreen: React.FC<BannedServerScreenProps> = ({ serverName }) => {
  const { currentServer, leaveServer, setCurrentServer, setCurrentChannel } = useServerStore();

  const handleLeave = async () => {
    if (!currentServer) return;
    try {
      await leaveServer(currentServer.id);
    } catch {
      // ignore — maybe owner
    }
    setCurrentServer(null);
    setCurrentChannel(null);
  };

  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-8">
      <div className="w-20 h-20 rounded-full bg-error/15 flex items-center justify-center mb-6">
        <ShieldBan className="w-10 h-10 text-error" />
      </div>
      <h1 className="text-2xl font-bold text-text-primary mb-2">Serveur banni</h1>
      <p className="text-text-secondary max-w-md mb-6">
        Le serveur <span className="font-semibold text-text-primary">{serverName}</span> a été banni de la plateforme Erozion pour violation des conditions d'utilisation.
      </p>
      <button
        onClick={handleLeave}
        className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-error/20 text-error hover:bg-error/30 transition-colors text-sm font-medium"
      >
        <DoorOpen className="w-4 h-4" />
        Quitter le serveur
      </button>
    </div>
  );
};

export default BannedServerScreen;
